import { removeWindowClass } from '@app/utils/helpers';
import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const loginByAuth = async (email: string, password: string) => {
  const token = await axios.post(`${constant.API_BASEPATH}/login`, {
    "email": email,
    "password": password
  }).then(function (res) {
    const resp = res.data;
    if (resp.Acknowledge == 1) {
      //localStorage.setItem('token', resp.Token); 
      Cookies.set(constant.Cookie_Name, resp.Token, { domain: constant.Cookie_Domain, secure: constant.Cookie_Secure, sameSite: constant.Cookie_SameSite });
      removeWindowClass('login-page');
      removeWindowClass('hold-transition'); 
    }  
    return resp;
  }).catch(err => {
    return err.response.data;
  }); 
  return token;
};

export const getProfile = async () => {
  let token = Cookies.get(constant.Cookie_Name);
  const response = await axios.get(`${constant.API_BASEPATH}/get-user`, { headers: { "Authorization": `Bearer ${token}` } }).then(function (res) {
    const resp = res.data;
    if (resp.Acknowledge == 1) {
      return resp;
    } else {
      return false;
    }
  }).catch(err => {
    return false;
  });
  return response;
};

export const updateProfile = async (data: any) => {
  try {
    let token = Cookies.get(constant.Cookie_Name);
    const response = await axios.put(constant.API_BASEPATH + '/update-profile', data, { headers: { "Authorization": `Bearer ${token}` } });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const Get365AuthorizationUrl = async () => {
  let postData = {
    "AppNamespace": null,
    "AppSid": "",
    "AppVersion": "0",
    "CheckVersion": null,
    "IpAddress": null,
    "Latitude": "0",
    "Longitude": "0",
    "DeviceToken": null,
    "IsKeepLogin": "false"
  };
  const response = await axios.post(`${constant.Get365AuthApiUrl}`, postData);
  return response;
};

export const Verify365Authorization = async (AuthCode: any) => {
  try {
    const response = await axios.post(constant.API_BASEPATH + '/verify-365-authorization', { token: AuthCode, api_url: constant.Verify365AuthApiUrl, redirect_url: constant.Get365RedirectUri });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
  // let postData = {
  //   "AppNamespace": null,
  //   "AppSid": "",
  //   "AppVersion": "0",
  //   "CheckVersion": null,
  //   "IpAddress": null,
  //   "Latitude": "0",
  //   "Longitude": "0",
  //   "DeviceToken": null,
  //   "IsKeepLogin": "false",
  //   "AuthCode": AuthCode,
  //   "ApplicationName": ""
  // };
  // const response = await axios.post(`${constant.Verify365AuthApiUrl}`, postData);
  // return response;
};





